import styled from "styled-components";

export const FrameLoader = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 170px;
`;

export const StyledLoader = styled.img`
  width: 360px;
  border-radius: 180px;
`;
